enum OrgRegulatingFilterType {
  multiselect
}

type OrgRegulatingFilterOption {
  count: Int
  default: Boolean
  display: String
  value: String
}

type OrgRegulatingFilterSchema {
  display_name: String
  param_name: String
  type: OrgRegulatingFilterType
  values: [OrgRegulatingFilterOption]
}

type OrgRegulatingFilter {
  filters: [OrgRegulatingFilterSchema]
}
